import React from 'react';
import { makeStyles } from '@material-ui/core';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(0, 1),
  },
  attribute: {
    flex: '0 0 20%',
    wordBreak: 'break-all',
    position: 'relative',
  },
  meta: {
    paddingRight: theme.spacing(6),
  },
}));

const TaskStatusViewLayout = () => {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      {resource.attr('name') ? (
        <div className={classes.attribute}>
          <MetaField
            className={classes.meta}
            attr="name"
          />
        </div>
      ) : null }
      {resource.attr('dueDate') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="dueDate" />
        </div>
      ) : null }
      {resource.attr('priority') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="priority" />
        </div>
      ) : null }
      {resource.attr('description') ? (
        <div className={classes.attribute}>
          <MetaField className={classes.meta} attr="description" />
        </div>
      ) : null }
    </div>
  );
};

export default TaskStatusViewLayout;
